import React, { PropsWithChildren, HTMLProps } from "react";
import Typography from "common/Typography/Typography";
import { FixMeLater } from "types";
import { typography } from "@shared/common/Themes/typography";
import { TypographyProps } from "@shared/common/Typography/Typography";

interface TitleProps
  extends PropsWithChildren<TypographyProps>,
    Omit<HTMLProps<HTMLDivElement>, "type"> {
  level?: number;
  innerRef?: any;
  as?: any;
  className?: string;
}

const Title: React.FunctionComponent<TitleProps> = React.forwardRef(
  (
    { as, type, $weight, $size, level = 1, innerRef, className, ...props },
    ref
  ) => {
    const hTag = `h${level}`;
    let size = $size || hTagToSize[hTag];
    return (
      <Typography
        className={className}
        as={as || hTag}
        type={type}
        $weight={$weight}
        $size={size}
        ref={innerRef || ref}
        {...props}
      />
    );
  }
);

Title.defaultProps = {
  $weight: typography.fontWeights.MEDIUM,
  type: "primary",
  level: 1,
};

const hTagToSize: FixMeLater = {
  h1: typography.fontSizes.XXL,
  h2: typography.fontSizes.XL,
  h3: typography.fontSizes.L,
  h4: typography.fontSizes.M,
  h5: typography.fontSizes.S,
};

export default Title;
